import { render, staticRenderFns } from "./resultkesehatanrohani.vue?vue&type=template&id=2421be96&"
import script from "./resultkesehatanrohani.vue?vue&type=script&lang=js&"
export * from "./resultkesehatanrohani.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports